module.exports = __webpack_public_path__ + "img/tickets-color.ecda9cf7.svg";